import { render, staticRenderFns } from "./FdTerm.vue?vue&type=template&id=3ec36e64"
import script from "./FdTerm.vue?vue&type=script&lang=js"
export * from "./FdTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports